import {BillingTransaction} from "../../../models";
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class ummaryStatementPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<BillingTransaction>}
 */
export class SummaryStatementPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/summary-statement';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingTransaction(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<BillingTransaction[]>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .then((response) => {

                if(response.collection){

                    response.collection = response.collection.map((attributes) => this.newModel(attributes));

                }

                return response;
            })
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/summary-statement.service.js